/** @flow */

import * as React from "react";
import { Icons } from "@components";
import classNames from "classnames";

import "./collapsable-sidebar.style.scss";

type Props = $Exact<{
  onToggle: (isExpanded: boolean) => any,
  isExpanded: boolean,
  children: React$Node,
  className?: string,
  showCollapsedPlaceholder?: boolean,
  collapsedPlaceholderLabel?: string,
  collapsedPlaceholderIcon?: React$Element<any>,
  collapsedWidth: number,
  collapsedMaxWidth?: number,
  align: "right" | "left",
  collapsedSectionClickable?: boolean,
}>;

export class CollapsableSidebar extends React.Component<Props> {
  static defaultProps = {
    collapsedWidth: 80,
    align: "right",
  };

  handleExpand = () => {
    !this.props.isExpanded && this.props.onToggle(true);
  };

  handleCollapse = () => {
    this.props.isExpanded && this.props.onToggle(false);
  };

  handleSidebarClick = () => {
    if (!this.props.collapsedSectionClickable) {
      return;
    }

    this.handleExpand();
  };

  handleExpandButtonClick = () => {
    if (this.props.isExpanded) {
      this.handleCollapse();
      return;
    }

    if (this.props.collapsedSectionClickable) {
      return;
    }

    this.handleExpand();
  };

  renderCollapsedSidebarPlaceholder = () => (
    <div className="collapsable-sidebar__view-record-box">
      <div className="collapsable-sidebar__view-record">
        {this.props.collapsedPlaceholderIcon &&
          React.cloneElement(this.props.collapsedPlaceholderIcon, {
            className: "mr-2",
          })}
        <div>{this.props.collapsedPlaceholderLabel}</div>
      </div>
    </div>
  );

  renderCollapsedSidebarContent = () => {
    if (this.props.showCollapsedPlaceholder) {
      return this.renderCollapsedSidebarPlaceholder();
    }

    return <div className="collapsable-sidebar__content-wrapper">{this.props.children}</div>;
  };

  get width() {
    return this.props.isExpanded ? "840px" : `${this.props.collapsedWidth}px`;
  }

  get maxWidth() {
    return this.props.isExpanded
      ? "840px"
      : `${this.props.collapsedMaxWidth || this.props.collapsedWidth}px`;
  }

  render() {
    return (
      <React.Fragment>
        {this.props.isExpanded && (
          <div className="collapsable-sidebar-overlay" onClick={this.handleCollapse} />
        )}
        <div
          className={classNames("collapsable-sidebar d-flex", this.props.className, {
            "collapsable-sidebar--expanded": this.props.isExpanded,
            "collapsable-sidebar--aligned-right": this.props.align === "right",
            "collapsable-sidebar--aligned-left": this.props.align === "left",
            "collapsable-sidebar--collapsed-clickable": this.props.collapsedSectionClickable,
          })}
          style={{ minWidth: this.width, maxWidth: this.maxWidth }}
          onClick={this.handleSidebarClick}
        >
          <div className="collapsable-sidebar__trapezoid" onClick={this.handleExpandButtonClick}>
            <Icons.ContextTriangleIcon className="collapsable-sidebar__trapezoid-triangle" />
          </div>
          {!this.props.isExpanded && this.renderCollapsedSidebarContent()}
          {this.props.isExpanded && (
            <div className="collapsable-sidebar__content-wrapper">{this.props.children}</div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default CollapsableSidebar;
